"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnhancer = void 0;
const react_1 = __importStar(require("react"));
const ldClient_1 = require("./ldClient");
const util_1 = require("./util");
const createEnhancer = (ld, initialFeatureSwitches, Provider, config) => {
    const { waitForReady, hotReload } = config;
    return (Comp) => {
        function Enhanced(props) {
            const [featureSwitches, setFeatureSwitches] = react_1.default.useState(initialFeatureSwitches);
            const [showChildren, setShowChildren] = react_1.default.useState(false);
            const onFeatureFlagChange = react_1.useCallback((flags) => {
                const changes = util_1.diffFlagChanges(featureSwitches, flags);
                if (!changes)
                    return;
                setFeatureSwitches({
                    ...featureSwitches,
                    ...changes,
                });
            }, [featureSwitches]);
            const setFeatureSwitchValue = (flag, value) => {
                setFeatureSwitches((prev) => ({
                    ...prev,
                    [flag]: value,
                }));
            };
            const replaceAllFeatureSwitches = (data) => {
                setFeatureSwitches(data);
            };
            const getAndSetFeatureSwitches = () => {
                setFeatureSwitches(
                // get feature flags from LD
                ld.prepareFeatureSwitches(initialFeatureSwitches));
            };
            react_1.useEffect(() => {
                // if not wait for LD sdk to be ready, show child comp directly
                if (!waitForReady)
                    setShowChildren(true);
                ld.waitUntilReady()
                    .then(getAndSetFeatureSwitches)
                    .finally(() => setShowChildren(true));
            }, []);
            react_1.useEffect(() => {
                if (!hotReload)
                    return;
                // listen to feature flag change
                const unlisten = ld.listen(onFeatureFlagChange);
                const stopListening = ld.startListening();
                return () => {
                    unlisten();
                    stopListening();
                };
            }, [onFeatureFlagChange]);
            react_1.useEffect(() => {
                ldClient_1.FlagManager.setFeatureSwitches(featureSwitches);
            }, [featureSwitches]);
            react_1.useEffect(() => {
                // after user identified, get user's flags
                ld.onIdentiferChange = getAndSetFeatureSwitches;
                return () => {
                    ld.onIdentiferChange = undefined;
                };
            }, []);
            const contextValue = react_1.useMemo(() => ({
                featureSwitches,
                replaceAllFeatureSwitches,
                setFeatureSwitchValue,
                flagManager: ld,
            }), [featureSwitches]);
            return (react_1.default.createElement(Provider, { value: contextValue }, showChildren && react_1.default.createElement(Comp, Object.assign({}, props))));
        }
        Enhanced.displayName = "feature-switch-enhanced-" + Comp.displayName;
        return Enhanced;
    };
};
exports.createEnhancer = createEnhancer;
